import type { RouteRecordRaw } from "vue-router";
import { guardInboxAccess } from "@/config/router/navigationsGuards/guardInbox";

const MODULE_NAME = "INBOX";

const inboxRoutes: Array<RouteRecordRaw> = [
  {
    path: "/inbox",
    name: "Inbox",
    component: () => import("@/views/inbox/Inbox.vue"),
    beforeEnter: [guardInboxAccess],
    meta: {
      requiresAuth: true,
      navbarNotRequired: false,
      titleTranslationKey: "pageTitle.inbox",
    },
  },
];

export default inboxRoutes.map((route) => ({
  ...route,
  meta: { ...route.meta, moduleName: MODULE_NAME },
}));
